function getReservationCollections() {
    const $reservationCollections = $("#reservationCollections");
    let collections = [];
    let reservationCollections = $reservationCollections.text();
    if(reservationCollections) {
        reservationCollections = reservationCollections.replace("},]", "}]");
        collections = JSON.parse(reservationCollections);
    }
    return collections;
}

function getProduct(handle) {
    return $.ajax({
        dataType: "json",
        url: '/products/' + handle + '.js',
        async: false
    }).responseJSON;
}

function getCartProducts() {
    let products = [];
    const cartItems = $.ajax({dataType: "json", url: '/cart.js', async: false}).responseJSON.items;

    if (cartItems.length) {
        cartItems.forEach(function (cartItem) {
            const product = getProduct(cartItem.handle);
            if (product) {
                products.push(product);
            }
        });
    }
    return products;
}

const RESERVED_TAG = "reserved";


function validateAddable(button) {
    const $button = $(button);
    const productId = $button.data("product-id");
    const isReservation = $button.data("is-reserved");

    const products = getCartProducts();
    if(!products) return false;

    let isIncludeReservationProduct = false;
    let isIncludeNormalProduct = false;
    const reservationProductIds = [];

    products.forEach(function (product) {
        if(product.tags.includes(RESERVED_TAG)) {
            reservationProductIds.push(product.id);
            isIncludeReservationProduct = true;
        } else {
            isIncludeNormalProduct = true;
        }
    });

    if((!isReservation && isIncludeReservationProduct) || (isReservation && isIncludeNormalProduct)) {
        alert("予約商品は1点ずつお会計をお願いします。予約商品と、通常商品との同時決済はできません。カートよりその他の商品を削除してからご購入をお願いいたします。");
        return false;
    }

    // 予約商品のカート追加の検証
    if(isReservation) {
        if(!isIncludeReservationProduct) {
            return true; //カートに予約商品がない場合はOK
        }

        if(reservationProductIds.includes(productId)) {
            return true; //追加したい商品と同じものがすでにカートにある場合はOK
        }

        reservationProductIds.push(productId); //カート商品と追加したい予約商品のIDをまとめる

        let validate = false;
        getReservationCollections().forEach(function (reservationCollection) {
            if(validate === false) {
                const collectionProductIds = reservationCollection.collection.map(function (product) {
                    return product.id
                });

                let isValid = true;
                reservationProductIds.forEach(function (cartProductId) {
                    if (!collectionProductIds.includes(cartProductId)) {
                        isValid = false; //コレクションにカート商品と追加したい商品のIDが含まれない場合はfalse
                    }
                });

                // コレクションに全ての商品のIDを含むことが確認できたらtrue
                validate = isValid;
            }
        });

        if(!validate) {
            alert("複数の予約商品を一緒にカートに入れることができません。");
            return false;
        }
    }

    return true;
}
window.validateAddable = validateAddable;